import { useOrgListData } from 'auth'
import PageShell from 'components/PageShell'
import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { SizableText, XStack } from 'tamagui'
import Earnings from './Earnings'
import Overview from './Overview'
import Referrals from './Referrals'

const TABS = ['Overview', 'Referrals', 'Earnings'] as const
type Tab = (typeof TABS)[number]

/** Person-level affiliate dashboard (not org-scoped). Gated on the isAffiliate flag. */
export default function AffiliateApp() {
    const { orgListUserData } = useOrgListData()
    const [tab, setTab] = useState<Tab>('Overview')

    if (!orgListUserData.isAffiliate) {
        return (
            <Navigate
                to="/"
                replace
            />
        )
    }

    return (
        <PageShell title="Refer & Earn">
            <XStack
                gap="$4"
                borderBottomWidth={1}
                borderBottomColor="$borderColor"
                marginBottom="$4"
            >
                {TABS.map(t => (
                    <SizableText
                        key={t}
                        cursor="pointer"
                        paddingVertical="$2"
                        fontWeight={tab === t ? '700' : '400'}
                        color={tab === t ? '$color' : '$colorMuted'}
                        borderBottomWidth={2}
                        borderBottomColor={tab === t ? '$primary' : 'transparent'}
                        onPress={() => setTab(t)}
                    >
                        {t}
                    </SizableText>
                ))}
            </XStack>

            {tab === 'Overview' && <Overview />}
            {tab === 'Referrals' && <Referrals />}
            {tab === 'Earnings' && <Earnings />}
        </PageShell>
    )
}
